'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

require('ricola3');

var _angularResource = require('angular-resource');

var _angularResource2 = _interopRequireDefault(_angularResource);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _app = require('./app/');

var _app2 = _interopRequireDefault(_app);

var _creditRequest = require('./credit-request/');

var _creditRequest2 = _interopRequireDefault(_creditRequest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var app = angular.module('webPublicClient', ['rc', _angularResource2.default, _angularUiRouter2.default, _app2.default.name, _creditRequest2.default.name]);

(0, _angular.bootstrap)(document.body, [app.name], {
  strictDi: true
});

exports.default = app.name;


// WEBPACK FOOTER //
// ./src/index.js